import { useEffect, useState, useRef, useTransition } from 'react';

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 900);
  const [, startTransition] = useTransition();

  useEffect(() => {
    const handleResize = () => {
      startTransition(() => setIsMobile(window.innerWidth < 900));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // eslint-disable-line

  return isMobile;
}

export function useIsTablet() {
  const [isTablet, setIsTablet] = useState(window.innerWidth >= 900 && window.innerWidth <= 1366);
  const [, startTransition] = useTransition();

  useEffect(() => {
    const handleResize = () => {
      startTransition(() => setIsTablet(window.innerWidth >= 900 && window.innerWidth <= 1366));
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []); // eslint-disable-line

  return isTablet;
}

export function useInterval(callback, delay) {
  const savedCallback = useRef(callback);

  useEffect(() => {
    savedCallback.current = callback;
  }, [callback]);

  useEffect(() => {
    if (delay === null) {
      return;
    }

    const id = setInterval(() => savedCallback.current(), delay);

    return () => clearInterval(id); // eslint-disable-line
  }, [delay]);
}
